<template>
    <va-edit-layout>
        <RentalTransactionEventTaxWithheldCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RentalTransactionEventTaxWithheldCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
